export default "__VITE_ASSET__CdZjwUBs__"